 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		81: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"defaultVendors~Accordion~ApartmentCards~ApartmentHero~ApartmentSearch~AreaMap~ArticleCardList~Articl~07fecf36","1":"defaultVendors~ApartmentCards~ApartmentHero~ApartmentSearch~AreaMap~ArticleCardList~ArticleContent~A~e0480d06","2":"defaultVendors~Accordion~ApartmentCards~ApartmentHero~ApartmentSearch~AreaMap~ArticleCardList~Articl~4268f848","3":"defaultVendors~Accordion~ApartmentCards~ApartmentHero~ApartmentSearch~ArticleCardList~ArticleListing~27c953ca","4":"defaultVendors~Accordion~ApartmentCards~ApartmentHero~ApartmentSearch~ArticleCardList~ArticleListing~a92b838a","5":"defaultVendors~Accordion~ApartmentCards~ApartmentHero~ApartmentSearch~ArticleCardList~AwardsCarousel~cabe1eed","6":"defaultVendors~Accordion~ApartmentCards~ApartmentHero~ApartmentSearch~ArticleCardList~AwardsCarousel~031269a0","7":"defaultVendors~Accordion~ApartmentCards~ApartmentHero~ApartmentSearch~ArticleCardList~AwardsCarousel~2db2c737","8":"defaultVendors~ApartmentCards~ArticleCardList~AwardsCarousel~ContentSignpostCards~DevelopmentCards~D~8b7c39fa","9":"default~Accordion~ApartmentCards~ArticleCardList~AwardsCarousel~ContentSignpostCards~DevelopmentCard~9de29c0d","10":"defaultVendors~ApartmentCards~ArticleCardList~AwardsCarousel~ContentSignpostCards~DevelopmentCards~F~362f76cc","11":"default~ApartmentCards~ArticleCardList~AwardsCarousel~ContentSignpostCards~DevelopmentCards~FloorPla~39d879c5","12":"defaultVendors~ArticleCardList~ArticleListing~BlogHero~InsightHero~StickyArticleList","13":"defaultVendors~CommuteTimeCalculator~DownloadForm~Form~ModalForm~TabbedForms","14":"default~DownloadForm~Form~ModalForm~TabbedForms","15":"defaultVendors~ApartmentSearch~ArticleListing~TabbedForms","16":"defaultVendors~ArticleContent~BlogRichText~RichText","17":"default~ApartmentHero~DevelopmentHero~HomepageHeroBanner","18":"default~AreaMap~CommuteTimeCalculator~DevelopmentsMap","19":"defaultVendors~ApartmentSearch~Header","20":"defaultVendors~CommuteTimeCalculator~DevelopmentsMap","21":"default~ApartmentSearch~Header","22":"default~BlogHero~InsightHero","23":"default~Form~TabbedForms","24":"default~NeighborhoodLandmarkListing~NeighborhoodMap","25":"Accordion","26":"ApartmentCards","27":"ApartmentHero","28":"ApartmentSearch","29":"AreaMap","30":"ArticleCardList","31":"ArticleContent","32":"ArticleGlobalStyles","33":"ArticleListing","34":"AuthorSummary","35":"AwardsCarousel","36":"BlogHero","37":"BlogRichText","38":"Breadcrumbs","39":"CommuteTimeCalculator","40":"ContentSignpostCards","41":"CookieDeclaration","42":"CtaSection","43":"DevelopmentCards","44":"DevelopmentHero","45":"DevelopmentInformationCards","46":"DevelopmentPanel","47":"DevelopmentsMap","48":"DownloadForm","49":"FloorPlans","50":"FloorPlansSimple","51":"Footer","52":"Form","53":"GridGallery","54":"GroupedIconList","55":"Header","56":"HomepageHeroBanner","57":"ImageGalleryCarousel","58":"ImageHighlighter","59":"InPageNavigation","60":"InlineImage","61":"InnerPageHero","62":"InsightHero","63":"InstagramFeedEmbed","64":"LocationStats","65":"Media","66":"ModalForm","67":"NeighborhoodBanner","68":"NeighborhoodImgBanner","69":"NeighborhoodLandmarkListing","70":"NeighborhoodMap","71":"ProfileCarousel","72":"RichText","73":"ScrollBasedGallery","74":"ShareButtons","75":"SocialPostEmbed","76":"SplitContent","77":"StickyArticleList","78":"TabbedForms","79":"TestimonialCarousel","80":"VirtualTour","82":"defaultVendors~ApartmentHero","83":"defaultVendors~ApartmentSearch","84":"defaultVendors~CommuteTimeCalculator","85":"defaultVendors~ModalForm","86":"defaultVendors~NeighborhoodLandmarkListing","87":"defaultVendors~NeighborhoodMap"}[chunkId]||chunkId) + "-" + {"0":"49d83847d69893bcc469","1":"4575aff5f8f59550eafb","2":"6b74c9ed19f2eef6bded","3":"8ac3d4b8eff4bd1289c0","4":"905de0fa8338158ad20d","5":"b33ddc4db4ff9c468b5c","6":"dc18ceb4a0f455e05a4b","7":"cd2b07b1e5b0c34a52f6","8":"c74e7f43f9fe6add915c","9":"f3156d2de8fbc26a6e5c","10":"4a53e7b3cd20e68af015","11":"ed897a233e8207727725","12":"e3aac8e5665bb6dfc873","13":"67447096b14d2d31ffd4","14":"4be2fcd909399d8c57b1","15":"072820a6d8e7ac4d1c47","16":"4bb459d7ffbbf19c5c25","17":"40e4840fc5c7fd19c9b7","18":"eb1ed7f8e3269958bea7","19":"4da45fa58c6d63958175","20":"bb92e9c0714f164dfea1","21":"7245280820f9b9cb34fe","22":"cab29489d82da936cd83","23":"43390bcaa75057c37ab7","24":"6aa5dfc83aa5a512560f","25":"5e5228d9e7d75619b740","26":"ddf03812664188ff24a7","27":"84f074a6b8bfc86cc65a","28":"a2dd15b7659f46995808","29":"efe214c0cf8351613dc3","30":"44bd50ea88e546f056e1","31":"30ba43bfad0f0f6a3bb4","32":"b567503e0961a29f0baf","33":"05d45d4cea924313607b","34":"debc40ce1b24eddd36b8","35":"04aa81145c821a59b87f","36":"45b4220b693276d389d6","37":"13a70837a159616ca867","38":"ac0e418960edcf150e94","39":"0cafbab9df4f55825bae","40":"166d1aeb13aac64bdda4","41":"1a817c85ed6483e4d984","42":"00b95c4ce023a5bf27f1","43":"59280d9c4efed909fe04","44":"756a5401b78162a30598","45":"ab239a5559a79bb52037","46":"15a6628d0b52141ec3b5","47":"7b2557dc2034b038f08d","48":"c4b2e3afd95706d2bd66","49":"eff1aa3dad2ae72bcda3","50":"b8f880292440fcb59e45","51":"ac49b0744c2d1ff6b449","52":"4e8f118d6a55a03a4e5c","53":"bc2a7425e626e2fa3a7b","54":"2dadab03cc5807530650","55":"2e494ad45d1e85a95b34","56":"07639d687235407a76b4","57":"d49d68d4429ae0d61661","58":"2a912ff5c59432c1c993","59":"76366903c913989788d9","60":"7a0ba59f7152e0692d3d","61":"226faa26c9398c5a68e6","62":"b9283c906201c326602b","63":"7db7e43dd224bc76768e","64":"af0a342f00cc0ec479f4","65":"ab69216b8e253841e348","66":"74880e29db434477e297","67":"af77d0a6039b16a13dbc","68":"067f4efda946b9886d2a","69":"852d7ee46c091e655db7","70":"6f4a4312b6bc350f4fe4","71":"f721bf8484bfe77c91f2","72":"3336a87589aff20e0d37","73":"f55ade33482e687a31b6","74":"30c20a709ec868e35708","75":"b5865bf0ffc1d4212de7","76":"eb642e751237453285a8","77":"ec6fb21e875425cf0de9","78":"5358940c110bb10d6707","79":"3735136afab3814c12ac","80":"5e51fec291047b00a50a","82":"a8e2d1a4a962a6f19fbf","83":"2cb0042d92830885fc88","84":"b1e196eab9b36eb51068","85":"90d41747c62e359f41ad","86":"e0fa52e31791ff488e2c","87":"eff8a05e4c0763b29bd7","90":"4fb89d9f94e15eb55c49","91":"93332b1c0ddbe580fd5c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/sitefiles/next-gen/dist/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = this["webpackJsonp"] = this["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 475);
